export default "__VITE_ASSET__gFaMHYNU__"